import { useExport } from './useExport'
import {
  createPlanDetailsExport,
  getPlanDetailsExport,
  type CreatePlanExportRequest,
} from '@/api/planExports'

/**
 * Hook to export detailed assortment-plan data.
 */
export function useExportPlanDetails() {
  const exportHook = useExport<CreatePlanExportRequest>({
    createExportFn: createPlanDetailsExport,
    getExportFn: getPlanDetailsExport,
    filenamePrefix: 'assortment-plan-details',
  })

  return {
    ...exportHook,
    exportPlanDetails: exportHook.startExport,
  }
}

export type { ExportStatus, ExportState } from './useExport'
